<template>
    <div class="timeline" :class="dark ? 'dark' : ''">
        <template v-for="(item, index) in items">
            <span class="timeline-year-badge" :key="index" v-if="item.position === '' || item.title === undefined || item.title === ''"> 
                <span>{{ item.year }}</span>
            </span>
            <template v-else>
                <div class="timeline-item" :key="index">
                    <div class="timeline-item-content">
                        <p v-if="item.position > 0" class="position">
                            <!-- $i18n.locale -->
                            <span v-if="$i18n.locale == 'pl'">{{ item.position }}. Miejsce</span>
                            <span v-else>
                                <span v-if="item.position == 1">1st</span>
                                <span v-else-if="item.position == 2">2nd</span>
                                <span v-else-if="item.position == 3">3rd</span>
                                <span v-else>{{ item.position }}th</span>
                                Place
                            </span>
                            <!-- <span>{{ $t('homepage.achievements.position', {position: item.position}) }}</span> -->
                        </p>
                        <p v-else-if="item.position == 0" class="position">
                            {{ awardLabel(item) }}
                        </p>
                        <p v-else-if="item.position == -1" class="position">
                            {{ $t('homepage.achievements.construction') }}
                        </p>
                        <p v-else-if="item.position == -2" class="position">
                            {{ $t('homepage.achievements.kokos_water') }}
                        </p>
                        <p v-else-if="item.position == -3" class="position">
                            {{ $t('homepage.achievements.kokos_vehicle') }}
                        </p>
                        <p class="title">
                            {{ item.title }}
                        </p>
                        <p class="title"><em>
                            {{ item.boat }}
                        </em></p>
                        <p v-if="item.country" class="title"><em>
                            {{ $t(item.country) }}
                        </em></p>
                        <p class="year">
                            {{ $t('homepage.achievements.season', {year: item.year}) }}
                        </p>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'TimelineComponent',
        props: ['items', 'dark'],
        methods: {
            awardLabel(item) {
                const awardKey = item.year === 2026 && item.position === 0
                    ? 'homepage.achievements.innovation_prize'
                    : 'homepage.achievements.awarded';
                return this.$t(awardKey);
            }
        }
    }
</script>

<style lang="sass" scoped>
    .timeline
        width: 100%
        position: relative
        padding-top: 10px

        &:before
            position: absolute
            content: ''
            left: 50%
            width: 2px
            height: 99%
            border-left: 1px dashed #828282
            z-index: -1

        .timeline-item
            width: 50%
            position: relative
            margin-top: 30px

            &:nth-of-type(odd)
                text-align: right

                &:after
                    position: absolute
                    content: ''
                    top: 40%
                    right: -4px
                    width: 7px
                    height: 7px
                    background: #100B47
                    border-radius: 50%

            &:nth-of-type(even)
                margin-left: 50%

                &:before
                    position: absolute
                    content: ''
                    top: 40%
                    left: -3px
                    width: 7px
                    height: 7px
                    background: #100B47
                    border-radius: 50%

            .timeline-item-content
                padding: 20px

                .position,
                .title,
                .season
                    font-family: Inter, serif
                    font-style: normal
                    text-transform: capitalize
                    margin: 0

                .position
                    font-weight: 600
                    font-size: 1.2em
                    line-height: 1em
                    color: #100B47

                .title
                    margin-top: 10px
                    font-weight: 300
                    font-size: 1em !important
                    line-height: 1.2em
                    color: #100B47

                .year
                    margin-top: 10px
                    font-weight: 300
                    font-size: .6em
                    line-height: .1em
                    color: rgba(16, 11, 71, 0.6)

        .timeline-year-badge
            display: block
            margin: 15px auto 0
            text-align: center

            span
                font-family: Inter, serif
                padding: 2px 10px 2px 10px
                font-size: .5em !important
                background: #100B47
                border-radius: 40px
                color: #fff

    .dark
        &:before
            border-color: #fff !important
            z-index: 1

        *
            color: #fff !important

        .timeline-item
            &:before,
            &:after
                background: #fff !important

            .timeline-item-content
                .season
                    color: #9E9AAE !important

        .timeline-year-badge
            span
                background: #fff !important
                color: #000 !important

    //@media only display and (max-width: 599px)

</style>
